// Supabase fetch blocks for documents, notes, and knowledge base articles.
// Stale-while-revalidate: cached data renders instantly while a background
// refetch keeps it fresh.

export * from './createNote.js'
export * from './createKnowledgeArticle.js'
export * from './saveKbArticle.js'

export const documentsFetch = {
  method: 'select',
  from: 'workspaceProject.documents',
  order: 'updated_at',
  ascending: false,
  as: '~/documents',
  cache: '30s',
  transform: (rows) => ({
    documents: (rows || []).map(r => ({
      id: r.id,
      title: r.title || 'Untitled',
      folder: r.folder || 'company',
      type: r.type || 'doc',
      updatedAt: (r.updated_at || '').slice(0, 10),
      author: r.author || '',
      summary: r.summary || '',
      content: r.content || ''
    }))
  })
}

export const notesFetch = {
  method: 'select',
  from: 'workspaceProject.documents.notes',
  order: 'created_at',
  ascending: false,
  as: '~/notes',
  cache: '30s',
  transform: (rows) => ({
    notes: (rows || []).map(r => ({
      id: r.id,
      title: r.title || 'Untitled',
      content: r.content || '',
      author: r.author || '',
      source: r.source || 'member',
      createdAt: (r.created_at || '').slice(0, 10),
      tags: r.tags || []
    }))
  })
}

export const kbArticlesFetch = {
  method: 'select',
  from: 'workspaceProject.documents.kb',
  order: 'updated_at',
  ascending: false,
  as: '~/kbArticles',
  cache: '1m',
  transform: (rows) => ({
    kbArticles: (rows || []).map(r => ({
      id: r.id,
      title: r.title || 'Untitled',
      category: r.category || 'getting-started',
      author: r.author || '',
      updatedAt: (r.updated_at || '').slice(0, 10),
      summary: r.summary || '',
      content: r.content || ''
    }))
  })
}
